export default __webpack_public_path__ + "static/media/visa.cfea2691.svg";